/* Publish by EComposer at 2026-09-29 11:31:19*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-m7pizmxv3uq"]=  window.__ectimmers["ecom-m7pizmxv3uq"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-m7pizmxv3uq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m7pizmxv3uq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9xel4ie64p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9xel4ie64p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sgce0cnt04').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sgce0cnt04', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-io7myq2jwrj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-io7myq2jwrj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bx9tqz9dv6m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bx9tqz9dv6m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xj17egex9pa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xj17egex9pa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g06a2kdjrhd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g06a2kdjrhd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4ysgysizcdk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ysgysizcdk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oyu99xccah').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oyu99xccah', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6n0r713mi6s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6n0r713mi6s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qbc2ceryrn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qbc2ceryrn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wrzfdc7b6qg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wrzfdc7b6qg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3imbmmauqnw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3imbmmauqnw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6b2s2ha6q8x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6b2s2ha6q8x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sm935qqegcg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sm935qqegcg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qezzbyqt0fa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qezzbyqt0fa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fi701vr4qt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fi701vr4qt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dytgzpg9k96').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dytgzpg9k96', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4fgcw53knr7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4fgcw53knr7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cv4cl05353').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cv4cl05353', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g96x7zqudj9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g96x7zqudj9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8cawb1tccrk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8cawb1tccrk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ifgva87np6h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ifgva87np6h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wr9l1dy3lrs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wr9l1dy3lrs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qglkb1e52gn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qglkb1e52gn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yon6hgdpvlk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yon6hgdpvlk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uklbf2x6u3p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uklbf2x6u3p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hz1qyd3jct8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hz1qyd3jct8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8vox8d4tgxr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8vox8d4tgxr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fzq0w2b3dj8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fzq0w2b3dj8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mvbuzb4lyl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mvbuzb4lyl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ksu6fecwe0d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ksu6fecwe0d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ux88ejmhx8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ux88ejmhx8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xnk6plo9fwr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xnk6plo9fwr', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-5q6w9h7btbk"]=  window.__ectimmers["ecom-5q6w9h7btbk"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-5q6w9h7btbk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5q6w9h7btbk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1x728arq7c6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1x728arq7c6', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qyctimmh78').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qyctimmh78', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wxotpec7mse').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wxotpec7mse', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kx54zmj8mvn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kx54zmj8mvn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xk1es8hnnoh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xk1es8hnnoh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-44qpz5geer7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-44qpz5geer7', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-95hmy5z1wrf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-95hmy5z1wrf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vyk3e9zyq5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vyk3e9zyq5', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}